import { t } from '@transifex/native'

const archivedText = t('archived')

export const fullNameFromParts = (firstName?: string | null, lastName?: string | null) => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}

export const fullNameWithEmail = (
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
) => {
  return `${firstName ?? ''} ${lastName ?? ''} ${email && `(${email})`}`.trim()
}

export const initialsForName = (firstName?: string | null, lastName?: string | null) => {
  const first = (firstName && firstName[0]) || ''
  const last = (lastName && lastName[0]) || ''
  return `${first}${last}`
}

export const fullNameWithStatus = (
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  isActive?: boolean,
) => {
  const fullName = fullNameFromParts(firstName, lastName)
  const archivedSuffix = isActive ? '' : ` (${archivedText})`

  if (fullName) {
    return `${fullName}${archivedSuffix}`
  }

  return email ? `${email}${archivedSuffix}` : ''
}
